// extracted by mini-css-extract-plugin
export var chat = "Chat-module--chat--1oRin";
export var chatPrimary = "Chat-module--chat--primary--34mCD";